import { ArrowLeft } from 'lucide-react';
import { Button } from './Button';

export function BackButton({ onClick, label }) {
  return (
    <Button variant="ghost" size="sm" className="mb-3 -ml-2 lg:hidden" onClick={onClick}>
      <ArrowLeft className="h-4 w-4" />
      {label}
    </Button>
  );
}
